import { shouldPolyfill } from '@formatjs/intl-displaynames/should-polyfill';
import { retry } from '@whitelabel/helpers/utils';

const loadIntlPolyfills = async () => {
  const imports = [];

  if (typeof Intl === 'undefined') {
    // @ts-ignore ts-migrate(7016) FIXME: Could not find a declaration file for module 'intl... Remove this comment to see the full error message
    await import('intl');
  }

  if (!Intl.PluralRules) {
    // @ts-ignore ts-migrate(7016) FIXME: Could not find a declaration file for module '@for... Remove this comment to see the full error message
    imports.push(import('@formatjs/intl-pluralrules/polyfill'));
  }

  // @ts-ignore ts-migrate(2339) FIXME: Property 'RelativeTimeFormat' does not exist on ty... Remove this comment to see the full error message
  if (!Intl.RelativeTimeFormat) {
    // @ts-ignore ts-migrate(7016) FIXME: Could not find a declaration file for module '@for... Remove this comment to see the full error message
    imports.push(import('@formatjs/intl-relativetimeformat/polyfill'));
  }

  if (shouldPolyfill()) {
    imports.push(
      retry(
        () =>
          import(
            '@formatjs/intl-getcanonicallocales/polyfill' /* webpackChunkName: `intl-polyfill-getcanonicallocales` */
          ),
      ),
    );

    imports.push(retry(() => import('@formatjs/intl-locale/polyfill' /* webpackChunkName: `intl-polyfill-locale` */)));
    imports.push(
      retry(() => import('@formatjs/intl-displaynames/polyfill' /* webpackChunkName: `intl-polyfill-displaynames` */)),
    );
  }

  if (imports.length > 0) await Promise.all(imports);
};

// Checks browser functionality and conditionally imports the required polyfills, used in conjunction with core-js
const loadPolyfills = async () => {
  // Load Intl polyfills in a separate async function so they don't block our other imports
  const polyfills = [loadIntlPolyfills()];

  if (typeof fetch === 'undefined') {
    // @ts-ignore ts-migrate(7016) FIXME: Could not find a declaration file for module 'what... Remove this comment to see the full error message
    polyfills.push(import('whatwg-fetch'));
  }

  if (!('scrollBehavior' in document.documentElement.style)) {
    // @ts-ignore ts-migrate(7016) FIXME: Could not find a declaration file for module 'smoo... Remove this comment to see the full error message
    polyfills.push(import('smoothscroll-polyfill').then((smoothscroll) => smoothscroll.default.polyfill()));
  }

  if (!SVGElement.prototype.contains) {
    SVGElement.prototype.contains = HTMLDivElement.prototype.contains;
  }

  await Promise.all(polyfills);
};

export default loadPolyfills;
